import React, { forwardRef, useCallback } from 'react';
import { VariableSizeList } from 'react-window';
import { PDFViewerPageRenderer } from '../PDFViewerPageRenderer';
import { PDFViewerVariableSizeListProps } from '../types';

const overscanCount = 1;

export const PDFViewerVariableSizeList = forwardRef(
	(props: PDFViewerVariableSizeListProps, listRef: React.Ref<VariableSizeList>) => {
		const {
			currentPage,
			height,
			rowHeight,
			itemCount,
			itemSize,
			itemData,
			setCurrentPage,
		} = props;

		const onScroll = useCallback(
			({ scrollDirection, scrollOffset }) => {
				const pagefactor = 2.25; // Update page number when atleast half of the page is visible
				const isForwardScroll = scrollDirection === 'forward';
				let thresholdPageValue = 0;

				if (isForwardScroll) {
					thresholdPageValue = Math.abs(currentPage * rowHeight - height / pagefactor);

					if (scrollOffset > thresholdPageValue) {
						setCurrentPage(num => num + 1);
					}
				} else {
					const page = currentPage > 1 ? currentPage - 1 : currentPage;
					thresholdPageValue = Math.abs(page * rowHeight - height / pagefactor);

					if (thresholdPageValue > scrollOffset) {
						setCurrentPage(num => Math.max(num - 1, 1));
					}
				}
			},
			[currentPage, rowHeight, height, setCurrentPage]
		);

		return (
			<VariableSizeList
				height={height}
				width={'100%'}
				itemCount={itemCount}
				itemSize={itemSize}
				itemData={itemData}
				overscanCount={overscanCount}
				ref={listRef}
				onScroll={onScroll}
			>
				{PDFViewerPageRenderer}
			</VariableSizeList>
		);
	}
);
